import React from 'react'

const Type = ({
                  opportunityId,
                  handleInput = () => {
                  },
                  productType = '',
                  setProductType=()=>{}
              }) => {

    return (
        <>
            {parseInt(opportunityId) === 7 ?
                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                    <select
                        className="form-control form-control-user"
                        onChange={(e) => {
                            handleInput('meta_data', e.target.value, 'Solution_Type', e)
                            setProductType(e.target.value)
                        }} required>
                        <option value="">Select Solution Type</option>
                        {productType === "Smart Parking Solution" ?
                            <>
                                <option value="Smart Parking Solution" selected>Smart Parking Solution</option>
                                <option value="FASTag Access Control">FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                            :productType === "FASTag Access Control" ?
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" selected>FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                            :productType === "PGS (Parking Guidance System)" ?
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" >FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)" selected>PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                            :productType === "Access Control" ?
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" >FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control" selected>Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                            :productType === "Inventory Management" ?
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" >FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management" selected>Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                            :productType === "Others" ?
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" >FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others" selected>Others</option>
                            </>
                            :
                            <>
                                <option value="Smart Parking Solution" >Smart Parking Solution</option>
                                <option value="FASTag Access Control" >FASTag Access Control</option>
                                <option value="PGS (Parking Guidance System)">PGS (Parking Guidance System)</option>
                                <option value="Access Control">Access Control</option>
                                <option value="Inventory Management.">Inventory Management.</option>
                                <option value="Others">Others</option>
                            </>
                        }
                    </select>
                    <label className="large-label float-lb">
                        Solution Type <i className="bi bi-asterisk astrick-icon"></i>
                    </label>
                </div> : parseInt(opportunityId) === 3 ?
                    <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                        <select
                            className="form-control form-control-user"
                            onChange={(e) => {
                                handleInput('meta_data', e.target.value, 'Service_Type', e)
                                setProductType(e.target.value)
                            }} required>
                            <option value="">Select Service Type</option>
                            {productType === "Additional Parking Slots" ?
                                <>
                                    <option value="Additional Parking Slots" selected>Additional Parking Slots</option>
                                    <option value="Valet Services">Valet Services</option>
                                    <option value="EV Charging Station">EV Charging Station</option>
                                    <option value="DCC (Daily Car Cleaning)">DCC (Daily Car Cleaning)</option>
                                </> :
                                productType === "Valet Services" ?
                                <>
                                    <option value="Additional Parking Slots" >Additional Parking Slots</option>
                                    <option value="Valet Services" selected>Valet Services</option>
                                    <option value="EV Charging Station">EV Charging Station</option>
                                    <option value="DCC (Daily Car Cleaning)">DCC (Daily Car Cleaning)</option>
                                </> : productType === "EV Charging Station" ?
                                <>
                                    <option value="Additional Parking Slots" >Additional Parking Slots</option>
                                    <option value="Valet Services">Valet Services</option>
                                    <option value="EV Charging Station" selected>EV Charging Station</option>
                                    <option value="DCC (Daily Car Cleaning)">DCC (Daily Car Cleaning)</option>
                                </> : productType === "DCC (Daily Car Cleaning)" ?
                                <>
                                    <option value="Additional Parking Slots" >Additional Parking Slots</option>
                                    <option value="Valet Services">Valet Services</option>
                                    <option value="EV Charging Station">EV Charging Station</option>
                                    <option value="DCC (Daily Car Cleaning)" selected>DCC (Daily Car Cleaning)</option>
                                </> :
                                <>
                                    <option value="Additional Parking Slots" >Additional Parking Slots</option>
                                    <option value="Valet Services">Valet Services</option>
                                    <option value="EV Charging Station">EV Charging Station</option>
                                    <option value="DCC (Daily Car Cleaning)">DCC (Daily Car Cleaning)</option>
                                </>
                            }
                        </select>
                        <label className="large-label float-lb">
                            Service Type <i className="bi bi-asterisk astrick-icon"></i>
                        </label>
                    </div> : ''
            }
        </>
    )
}

export default Type